import produce from "immer";
import styled from "styled-components";
import { useFieldArray, Controller } from "react-hook-form";
import TSimpleRadio from "components/form/Field/TSimpleRadio";
import { TInput } from "components/form/Field/TInput";
import { StyledTitle } from "../../../../../pages/jobs/add";
function SelectedColorSelect(props) {
  const {
    setValue,
    printColorIndex,
    name,
    control,
    errors,
    trigger,
    watch,
    reset,
    getValues,
  } = props;

  const { fields, remove, append } = useFieldArray({
    control,
    name: `${name}.print_color[${printColorIndex}].selected_color`,
  });

  const handleprintColorTypeSelect = (printColorIndex, index) => {
    const selectColor = produce(getValues(), (draft) => {
      draft[name].print_color[printColorIndex].selected_color[
        index
      ].color = null;
      draft.cover.hot_stamping = watch("cover.hot_stamping");
    });
    reset(selectColor, { errors: true });
  };

  return (
    <>
      {fields.map((item, index) => {
        // watchCover[printColorIndex][printColorIndex]["selected_color"][index].type

        const watchSelectedColorType = watch(
          `${name}.print_color[${printColorIndex}].selected_color[${index}].type`
        );
        return (
          <StyledColorContainer key={item.id}>
            <StyledTitle>Color {index + 1}</StyledTitle>
            <TypeRadioContainer>
              <TSimpleRadio
                options={["CMYK", "PANTONE"]}
                defaultValue={item.type}
                control={control}
                name={`${name}.print_color[${printColorIndex}].selected_color[${index}].type`}
                errors={errors}
                trigger={trigger}
                setValue={setValue}
                className="color-type"
                size="small"
                onPilih={{
                  func: handleprintColorTypeSelect,
                  index: index,
                  printColorIndex: printColorIndex,
                }}
                noMt
              />
              <TSimpleRadio
                options={["CYAN", "MAGENTA", "YELLOW", "BLACK"]}
                defaultValue={item.color}
                control={control}
                name={`${name}.print_color[${printColorIndex}].selected_color[${index}].color`}
                errors={errors}
                trigger={trigger}
                setValue={setValue}
                cssHide={watchSelectedColorType !== "CMYK"}
                size="small"
                noMt
              />
              <TInput
                errors={errors}
                name={`${name}.print_color[${printColorIndex}].selected_color[${index}].color`}
                placeholder="Pantone Code"
                defaultValue={item.color}
                size={"small"}
                propsInput={{
                  control: control,
                }}
                cssHide={watchSelectedColorType !== "PANTONE"}
                noMb
              />
            </TypeRadioContainer>
          </StyledColorContainer>
        );
      })}
    </>
  );
}

const StyledColorContainer = styled.div`
  margin-top: ${(props) => props.theme.spacing[2]};
  display: flex;

  flex-direction: column;
`;

const TypeRadioContainer = styled.div`
  display: flex;
  align-items: center;

  .color-type {
    margin-right: ${(props) => props.theme.spacing[1]};
  }
`;

export default SelectedColorSelect;
